import { ConfigurationType } from 'data/types';

type StepCompleteConfiguration = Pick<ConfigurationType, 'condensers'>;

// The air_handlers step's requirementsMet predicate: every zone that has
// spaces carries an air handler. Shared by the step sidebar (utils/ui.ts) and
// the valid-systems watcher, which gates the full /valid-systems fetch on it.
export function everyZoneWithItemsHasAirHandler(
  config: StepCompleteConfiguration | undefined
): boolean {
  if (!config) return false;
  const zonesWithItems = config.condensers
    .flatMap((condenser) => condenser.zones)
    .filter((zone) => zone.zoneItems.length > 0);
  return (
    zonesWithItems.length > 0 &&
    zonesWithItems.every((zone) => zone.airHandler !== undefined)
  );
}
